var exports = {
  "Nr": "x127c5a35--4ea147--card",
  "$_": "x127c5a35--4ea147--media",
  "Qs": "x127c5a35--4ea147--content",
  "Ix": "x127c5a35--4ea147--facts",
  "QY": "x127c5a35--4ea147--geo",
};

module.exports = exports;
